import React from 'react';
import { Sparkles, ArrowRight } from 'lucide-react';
export function Impact() {
  const highlights = ['Eventos recientes.', 'Fotos de actividades comunitarias.', 'Historias de vecinos.', 'Proyectos antes y después.', 'Campañas de limpieza.', 'Reuniones importantes.', 'Apoyos a negocios locales.', 'Iniciativas para jóvenes y adultos mayores.'];
  return <section className="py-24 px-6 lg:px-8 bg-white" data-id="element-166">
      <div className="max-w-6xl mx-auto" data-id="element-167">
        <div className="text-center mb-16" data-id="element-168">
          <h2 className="text-3xl md:text-4xl font-bold text-charcoal mb-6" data-id="element-169">
            Impacto Local
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-170">
            La participación vecinal puede ayudar a visibilizar problemas,
            conectar recursos y fortalecer proyectos comunitarios.
          </p>
        </div>

        <div className="grid lg:grid-cols-12 gap-12 items-center" data-id="element-171">
          <div className="lg:col-span-5" data-id="element-172">
            <h3 className="text-2xl font-bold text-charcoal mb-6 flex items-center gap-2" data-id="element-173">
              <Sparkles className="text-sky w-6 h-6" data-id="element-174" />
              Aquí se pueden destacar:
            </h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-1 gap-4" data-id="element-175">
              {highlights.map((item, index) => <div key={index} className="flex items-center gap-3 text-gray-700 bg-softblue/50 p-3 rounded-lg border border-softblue-dark" data-id="element-176">
                  <ArrowRight className="w-4 h-4 text-sky shrink-0" data-id="element-177" />
                  <span className="font-medium" data-id="element-178">{item}</span>
                </div>)}
            </div>
          </div>

          <div className="lg:col-span-7" data-id="element-179">
            <div className="bg-softblue rounded-3xl overflow-hidden shadow-lg border border-softblue-dark" data-id="element-180">
              <div className="h-64 bg-gray-200 relative" data-id="element-181">
                <img src="https://images.unsplash.com/photo-1593115057322-e94b77572f20?q=80&w=2071&auto=format&fit=crop" alt="Limpieza comunitaria" className="w-full h-full object-cover" data-id="element-182" />
                <div className="absolute top-4 left-4 bg-warm text-charcoal text-sm font-bold px-3 py-1 rounded-full shadow-md" data-id="element-183">
                  Ejemplo de bloque de impacto
                </div>
              </div>
              <div className="p-8" data-id="element-184">
                <h4 className="text-2xl font-bold text-charcoal mb-4" data-id="element-185">
                  Proyecto destacado: Limpieza comunitaria en [zona o calle]
                </h4>
                <p className="text-gray-700 text-lg mb-6 leading-relaxed" data-id="element-186">
                  Vecinos, voluntarios y representantes comunitarios se
                  reunieron para mejorar un espacio público y promover un
                  vecindario más limpio y seguro.
                </p>
                <div className="bg-white p-4 rounded-xl border-l-4 border-sylmar" data-id="element-187">
                  <p className="font-bold text-charcoal" data-id="element-188">Resultado:</p>
                  <p className="text-gray-600" data-id="element-189">
                    Más participación, más comunicación y más conexión entre
                    vecinos.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}